import { Component, EventEmitter, Input, Output } from '@angular/core';
import type { InnogyComponentRendering } from '@core/jss-models';
import type {
  ImageField,
  RenderingField,
} from '@sitecore-jss/sitecore-jss-angular';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';
import { TrackLinkDirective } from '@analytics/events';
import { CSCaptureDirective } from '@legacy/utils-contentsquare';

export interface SingleFieldExplanationContent {
  title: RenderingField<string> | undefined;
  button: RenderingField<string> | undefined;
  content: RenderingField<string> | undefined;
  image?: RenderingField<ImageField> | undefined;
  imageLabel?: RenderingField<string> | undefined;
}

@Component({
  selector: 'wl-more-info-button[rendering][explanation][giveMoreInfo]',
  templateUrl: './more-info-button.component.html',
  styleUrls: [],
  standalone: true,
  imports: [JssModule, TrackLinkDirective, CSCaptureDirective],
})
export class MoreInfoButtonComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering!: InnogyComponentRendering | undefined;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() explanation?: SingleFieldExplanationContent;
  @Output()
  giveMoreInfo: EventEmitter<SingleFieldExplanationContent> =
    new EventEmitter<SingleFieldExplanationContent>();

  get explanationVisible() {
    return (
      this.explanation?.button?.value &&
      this.explanation?.title?.value &&
      this.explanation?.content?.value
    );
  }
}
